export var DOUBLE_TAP_INTERVAL = 250;
export var DEFAULT_COUNTRY = 'en_au';
export var NAVIGATOR_GRID_GAP = 5;
export var CONTENT_TYPES = {
  Page: 'flyer_page',
  Extra_Page: 'extra_page',
  Slide: 'slide'
};
export var EXTRA_TYPES = ['FLYER_INFO'];